import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../Generic/Button';
import Typography from '../../Generic/Typography';
import styles from './Menu-tw-styles';
import DOMPurify from 'isomorphic-dompurify';

export default function MenuList(props) {
  const { menuSlots, resetMenu } = props;
  return (
    <li className={classNames(styles.subMenuList)}>
      {menuSlots.menuItemsCollection.items.map((menuitem, i) => {
        return (
          <Button
            key={i}
            to={menuitem.menuLink}
            className={classNames(styles.subMenuLinks, menuitem.styles)}
            onClick={resetMenu}
            tabIndex={0}
          >
            <Typography
              key={i}
              component="div"
              className={classNames(styles.subMenuListText)}
              dangerouslySetInnerHTML={{
                __html:DOMPurify.sanitize( menuitem.menuText),
              }}
            />
          </Button>
        );
      })}
    </li>
  );
}

MenuList.propTypes = {
  menuSlots: PropTypes.oneOfType([PropTypes.object]),
  resetMenu: PropTypes.func.isRequired,
};
// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const MenuList = ({prop = val, menuSlots = { }) =>
MenuList.defaultProps = {
  menuSlots: {},
};
